import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { atualizarItemNoOrcamentoLegado } from "./atualizarItemNoOrcamentoLegado"

import globalMU from "globalMU"

export type DefinirFilialTransferenciaParams = {
    identificadorItem: number,
    codigoFilialTransferencia: string,
    atualizarEstadoLegadoImediatamente?: boolean
    itemLegado?:any

}

export async function definirFilialTransferenciaItem(params: DefinirFilialTransferenciaParams) {
    try {
        globalMU.blockUI({tryPassiveLoading: true})
        
        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirFilialTransferencia(
            store.getState().orcamento.IdentificadorOrcamento,
            params.identificadorItem,
            params.codigoFilialTransferencia
        )

        atualizarItemNoOrcamentoLegado(orcamentoAtualizado, params.identificadorItem, params.atualizarEstadoLegadoImediatamente)
    } finally {
        globalMU.unblockUI()
    }
    
}